import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import BottomMessagePopUp from "../../../components/BottomMessagePopUp";
import { Dropdown } from "primereact/dropdown";

const AddOnDrivers = () => {
	const location = useLocation();
	const navigate = useNavigate();

	const [errorMessage, setErrorMessage] = useState("");
	const [isErrorVisible, setIsErrorVisible] = useState(false);

	const selectedAddOn = location.state?.addOn;

	const [selectedDays, setSelectedDays] = useState([]);
	const [selectedAmount, setSelectedAmount] = useState([]);
	const amounts = [
		{ name: "50", code: "50" },
		{ name: "100", code: "100" },
		{ name: "200", code: "200" },
	];

	const days = [
		{ name: "7", code: "7" },
		{ name: "14", code: "14" },
		{ name: "21", code: "21" },
	];

	useEffect(() => {
		console.log("selected sompo cart", selectedDays, selectedAmount);
		localStorage.setItem(
			"sompo_cart_selection",
			JSON.stringify({
				amount: selectedAmount.code,
				days: selectedDays.code,
			})
		);
	}, [selectedAmount, selectedDays]);

	if (!selectedAddOn) {
		return (
			<div className="content">
				<h3>No Add-on Selected</h3>
				<Button label="Go Back" onClick={() => navigate(-1)} />
			</div>
		);
	}

	const handleReturnClick = (e) => {
		e.preventDefault();
		const queryParameters = new URLSearchParams(window.location.search);
		const policyId = queryParameters.get("policy_id");

		navigate(
			policyId
				? `/get-quote/add-on-others?policy_id=${policyId}`
				: `/get-quote/add-on-others`,
			{
				replace: true,
				state: {
					...selectedAddOn,
					selectedPlan: {
						amount: selectedAmount.code,
						days: selectedDays.code,
					}, // Pass the sum_insured value here
				},
			}
		);
	};

	return (
		<div className="content">
			<div className="get-quote-container">
				<h3>{`${selectedAddOn.title}`}</h3>

				<div className="add-on-details border-radius-10 w-100 mb-3">
					<span className="mb-1">Amount</span>
					<Dropdown
						value={selectedAmount}
						onChange={(e) => setSelectedAmount(e.value)}
						options={amounts}
						optionLabel="name"
						placeholder="Select the amount"
						className="w-full md:w-14rem"
					/>
				</div>

				<div className="add-on-details border-radius-10 w-100 mb-8rem">
					<span className="mb-1">Days</span>
					<Dropdown
						value={selectedDays}
						onChange={(e) => setSelectedDays(e.value)}
						options={days}
						optionLabel="name"
						placeholder="Select the days"
						className="w-full md:w-14rem"
					/>
				</div>

				<div className={`sticky-bottom `}>
					<div className="d-flex flex-row flex-wrap justify-content-between align-items-center">
						{/* Selected Plan and Logo Section */}
						<div className="plan-details">
							<span className="text-left formatted-text">
								{`Selecting Add-Ons for`}
							</span>
							<br />
							<span className="fw-bold color-heading">
								{selectedAddOn.title}
							</span>
							<p className="my-0 fw-bold insurer-name"></p>
						</div>
						<div className="col-sm-6 w-50"></div>
					</div>
					<hr />
					<Button
						label="Return add-ons"
						className="btn-primary"
						onClick={(e) => handleReturnClick(e)}
					/>
					<BottomMessagePopUp
						message={errorMessage}
						type="error"
						isVisible={isErrorVisible}
						onClose={() => setIsErrorVisible(false)}
					/>
				</div>
			</div>
		</div>
	);
};

export default AddOnDrivers;
